const clsx = (classes: Record<string, boolean>) => {
  let renderedClasses: Array<string> = [];

  Object.entries(classes).forEach(([className, shouldRender]) => {
    if (shouldRender) renderedClasses.push(className);
  });

  return renderedClasses.join(' ');
};

export default clsx;
